<template>
    <header>
        <span>
            <div>{{ moduleName }}</div>
            <div>
                {{ diamReference }} <strong v-if="clientReference">{{ clientReference }}</strong>

                <router-link target="_blank" :to="`/module/${module && module.id}`">
                    <i class="fas fa-external-link-alt" aria-hidden="true"></i>
                </router-link>
            </div>
        </span>
        <OutlineButton @click="cancel">cancel</OutlineButton>
        <OutlineButton @click="save">save</OutlineButton>
    </header>
</template>

<script>
import OutlineButton from "@/plano/components/outline-button";

export default {
    props: { module: { type: Object } },
    components: { OutlineButton },
    methods: {
        cancel() {
            this.$emit("cancel");
        },
        save() {
            this.$emit("save");
        }
    },
    computed: {
        moduleName() {
            return this.module && this.module.terms.name[this.$t("trad")].value;
        },
        diamReference() {
            return this.module && this.module.infosArticle.diam_ref1 && this.module.infosArticle.diam_ref1.componentProperty.value;
        },
        clientReference() {
            return this.module && this.module.infosArticle.client_ref1 && this.module.infosArticle.client_ref1.componentProperty.value;
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../assets/css/themes.scss";
header {
    background-color: $color2;
    color: white;
    text-transform: uppercase;
    font-weight: 200;
    font-family: Oswald;
    font-size: 20px;
    display: flex;
    align-items: center;
    padding: 0px 20px;
    flex-direction: row;

    > :first-child {
        * {
            font-size: inherit;
        }

        a {
            margin-left: 20px;
            font-size: 18px;
            color: white;
        }

        font-size: inherit;
        flex-grow: 1;
    }

    button + button {
        margin-left: 15px;
    }
}
</style>



// WEBPACK FOOTER //
// edit-module-header.vue?3e0da156